require('./apps/BCOMS');


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx